import { makeStyles, css } from '@conexasaude/conexa-hero'
import { UseStylesProps } from './types'
import { paddingBottomValue } from './constants'

const useStyles = makeStyles<UseStylesProps>({
  root: (
    theme,
    { canShowActionBar, quantityOfButtonsInActionBar, isPhone },
  ) => css`
    padding-top: ${theme.spacing.xs};
    padding-left: ${theme.spacing.xxs};
    padding-right: ${theme.spacing.xxs};
    padding-bottom: ${paddingBottomValue({
      canShowActionBar,
      quantityOfButtonsInActionBar,
      isPhone,
    })};
    height: fit-content;
    border-radius: ${theme.border.radius.xl};
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    background: ${theme.colors.background.gray};
  `,

  content: css`
    flex: 1;
    width: 100%;
  `,

  footer: theme => css`
    flex: 0;
    width: 100%;
    margin-top: ${theme.spacing.sm};
    margin-bottom: ${theme.spacing.sm};

    @media (max-width: ${theme.grid.breakpoint.sm}) {
      margin-bottom: ${theme.spacing.lg};
    }
  `,

  layoutMenuContainer: theme => css`
    margin-bottom: ${theme.spacing.xs};

    hr {
      flex-grow: 1;
      border: none;
      border-bottom: 1px solid ${theme.colors.neutral[100]};
      margin-top: ${theme.spacing.xs};
    }
  `,
})

export { useStyles }
